import styled from "styled-components";

export const PrincipalDiv = styled.div`
    display: flex;
    background-color: var(--soft-setra-blue);
    height: 200px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;


export const CopyRight = styled.div`
    text-align: center;
    color: white;
    font-weight: normal;
    font-size: 14px;
    font-family: "Montserrat", Sans-serif;
    p {
        color: white;
    }
    strong {
        color: var(--setra-blue);
    }
`;